import React from "react";
import { motion } from "framer-motion";

const TeamHero = () => {
  return (
    <section className="team-hero">
      <div className="hero-video-container">
        <video 
          autoPlay 
          muted 
          loop 
          playsInline 
          className="hero-video"
        >
          <source src="/videos/workstation-preview.mp4" type="video/mp4" />
        </video>
        <div className="hero-overlay"></div>
      </div>
      
      <div className="hero-content">
        <motion.span 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="hero-kicker"
        >
          ESTABLISHED IN INNOVATION
        </motion.span>
        <motion.h1 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="hero-title"
        >
          A COLLECTIVE OF <br />
          <span className="italic gold-text">MASTERS & VISIONARIES</span>
        </motion.h1>
      </div>
      
      <div className="scroll-hint">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
      </div>
    </section>
  );
};

export default TeamHero;
